angular.module('TetherApp').factory('userService', [
    '$http',
    '$window',
    function ($http, $window) {

        let randomString = function (length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let deleteUser = function (userId) {
            let uri = '/api/v1/user/' + userId + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let disableUser = function (userId) {
            let uri = '/api/v1/user/' + userId + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                )
                + '/disable';
            return $http.post(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };


        let enableUser = function (userId) {
            let uri = '/api/v1/user/' + userId + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                )
                + '/enable';
            return $http.post(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        /**
         * Return list data
         * @returns {Object}
         */
        let getListsData = function () {
            if ($window.listsData !== undefined) {
                return $window.listsData;
            } else {
                return [];
            }
        };

        let toggleLock = function (userId) {
            return $http.put('/api/v1/user/' + userId + '/lock', {}, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        let togglePasswordReset = function (userId) {
            return $http.put('/api/v1/user/' + userId + '/password-reset', {}, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        return {
            getListsData: getListsData,
            deleteUser: deleteUser,
            disableUser: disableUser,
            enableUser: enableUser,
            toggleLock: toggleLock,
            togglePasswordReset: togglePasswordReset
        }

    }
]);
